import { DropdownOptionItem } from "../components/form/DropdownSelect";

export enum RENT_PRICE_OPTION {
    HOUR,
    HOURS,
    DAY,
    DAYS,
    WEEK,
    WEEKS,
    MONTH,
    MONTHS
}

export const multiPriceOptions: RENT_PRICE_OPTION[] = [RENT_PRICE_OPTION.HOURS, RENT_PRICE_OPTION.DAYS, RENT_PRICE_OPTION.WEEKS, RENT_PRICE_OPTION.MONTHS]

export enum RENT_PRICE_OPTION_LABELS {
    HOUR = "Tund",
    HOURS = "Tundi",
    DAY = "Päev",
    DAYS = "Päeva",
    WEEK = "Nädal",
    WEEKS = "Nädalat",
    MONTH = "Kuu",
    MONTHS = "Kuud"
}

export const rentPriceTypeOptions: DropdownOptionItem[] = [
    {val:  RENT_PRICE_OPTION.HOUR, label: RENT_PRICE_OPTION_LABELS.HOUR},
    {val:  RENT_PRICE_OPTION.HOURS, label: RENT_PRICE_OPTION_LABELS.HOURS},
    {val:  RENT_PRICE_OPTION.DAY, label: RENT_PRICE_OPTION_LABELS.DAY},
    {val:  RENT_PRICE_OPTION.DAYS, label: RENT_PRICE_OPTION_LABELS.DAYS},
    {val:  RENT_PRICE_OPTION.WEEK, label: RENT_PRICE_OPTION_LABELS.WEEK},
    {val:  RENT_PRICE_OPTION.WEEKS, label: RENT_PRICE_OPTION_LABELS.WEEKS},
    {val:  RENT_PRICE_OPTION.MONTH, label: RENT_PRICE_OPTION_LABELS.MONTH},
    {val:  RENT_PRICE_OPTION.MONTHS, label: RENT_PRICE_OPTION_LABELS.MONTHS}
]

